import { useQuery } from 'react-query';

import { getPortfolioTopHeroes as queryFn } from 'api/endPoints/getPortfolioTopHeroes';
import { IPortfolioTopHeroesComponentsList } from 'api/queries/getProjectScoreCardsSummary';
import { QueryKeys } from 'api/queryKeys';

export interface QueryResponse {
    componentsList: IPortfolioTopHeroesComponentsList;
    info?: IToolTip;
    name: string;
    numOfItems: number;
}

export const useQueryPortfolioTopHeroes = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['portfolioTopHeroes', params],
        queryFn: () => queryFn(params),
    });
};
